export * from './carta.service';
import { CartaService } from './carta.service';
export * from './ordem.service';
import { OrdemService } from './ordem.service';
export const APIS = [CartaService, OrdemService];
